import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import { FormBox } from '../../css';
import ErrorIcon from '../../../../assets/images/icon_error_messages.gif';

const InputField = ({
  label,
  type,
  errors,
  touched,
  name,
  placeholder,
  readOnly
}) => {
  return (
    <FormBox>
      <div className="main-content-form-headers">
        <span>{label}</span>
      </div>
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors[name] && touched[name] ? 'error' : ''
        }`}
      >
        <Field
          name={name}
          type={type}
          className="select-style"
          placeholder={placeholder}
          readOnly={readOnly}
        />
        <div className="error_messages">
          <span className="frg-body-font-14px">{errors[name]}</span>
        </div>
        <div id="username_error_icon" className="error_messages_icon">
          <img src={ErrorIcon} alt="error_icon" />
        </div>
      </div>
    </FormBox>
  );
};

InputField.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  errors: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  touched: PropTypes.any,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool
};

InputField.defaultProps = {
  type: 'text',
  placeholder: '',
  readOnly: false
};

export default InputField;
